import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Table
} from 'react-lib/frameworks/Table'
import {
  Button
} from 'semantic-ui-react'

const CardAllergyActionLogUX = (props: any) => {
    return(
      <div>
        <div
          id="CardAllergyActionLogUX-div-4"
          style={ {fontWeight: "bold", fontSize:"large",padding: "20px"}}>
          {props.languageUX === "en" ? "Audit log" : "ประวัติการบันทึกกิจกรรม"}
        </div>
        <div
          id="CardAllergyActionLogUX-div-3">
          
          <Table
            data={props.actionLogData}
            headers={props.languageUX === "en" ? "User,Action,Date - Time  " : "ผู้ใช้งาน,การดำเนินการ,วันที่เวลา"}
            id="CardAllergyActionLogUX-Table-1"
            keys="name,action,datetime"
            minRows="9"
            showPagination={false}
            style={{padding: "20px"}}>
          </Table>
        </div>
        <div
          id="CardAllergyActionLogUX-div-5"
          style={{display: "flex", justifyContent: "space-between", padding: "20px"}}>
          
          <div
            id="CardAllergyActionLogUX-div-2">
            {props.paginationComponent}
          </div>
          <Button
            id="CardAllergyActionLogUX-Button-7"
            onClick={props.onDismiss}>
            {props.languageUX === "en" ? "OK" : "ตกลง"}
          </Button>
        </div>
      </div>
    )
}


export default CardAllergyActionLogUX

export const screenPropsDefault = {"language":"TH"}

/* Date Time : Thu Sep 11 2025 08:09:07 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "seq": 0
    },
    {
      "from": "react-lib/frameworks/Table",
      "id": 1,
      "name": "Table",
      "parent": 3,
      "props": {
        "data": {
          "type": "code",
          "value": "props.actionLogData"
        },
        "headers": {
          "type": "value",
          "value": "ผู้ใช้งาน,การดำเนินการ,วันที่เวลา",
          "valueEN": "User,Action,Date - Time  "
        },
        "id": {
          "type": "value",
          "value": "CardAllergyActionLogUX-Table-1"
        },
        "keys": {
          "type": "value",
          "value": "name,action,datetime"
        },
        "minRows": {
          "type": "value",
          "value": "9"
        },
        "showPagination": {
          "type": "code",
          "value": "false"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"20px\"}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "code",
          "value": "props.paginationComponent"
        },
        "id": {
          "type": "value",
          "value": "CardAllergyActionLogUX-div-2"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAllergyActionLogUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ประวัติการบันทึกกิจกรรม",
          "valueEN": "Audit log"
        },
        "id": {
          "type": "value",
          "value": "CardAllergyActionLogUX-div-4"
        },
        "style": {
          "type": "code",
          "value": " {fontWeight: \"bold\", fontSize:\"large\",padding: \"20px\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardAllergyActionLogUX-div-5"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", padding: \"20px\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "ตกลง",
          "valueEN": "OK"
        },
        "id": {
          "type": "value",
          "value": "CardAllergyActionLogUX-Button-7"
        },
        "onClick": {
          "type": "code",
          "value": "props.onDismiss"
        }
      },
      "seq": 7,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardAllergyActionLogUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "TH"
  },
  "width": 80
}

*********************************************************************************** */
